module.exports = __webpack_public_path__ + "img/IT0000104539671.808c989d.png";